export const isWebGLRelatedError = (error: Error): boolean => {
    const message = error.message.toLowerCase();
    return message.includes('webgl') || message.includes('context');
};
